import * as React from 'react';
import '../ButtonActive/ButtonActive.css';
import { FieldProps } from 'formik'

type Props =  FieldProps  & {
    active: boolean;
    onClickedHandler: Function;
}
const ButtonActive: React.FC<Props> = ({ active, onClickedHandler, children }) => {

    return (
        <>
            <button  className={active ? 'button_active' : 'button'} onClick={() => onClickedHandler()}>
                {children}
            </button>
        </>
    )

}
export default ButtonActive


// WEBPACK FOOTER //
// ./src/components/formElements/ButtonActive/ButtonActive.tsx